import { CARD_WIDTH } from "../Card/styled";

import { CAROUSEL_GUTTER_WIDTH } from "./styled";

export const CARD_WITH_BORDER_WIDTH = CARD_WIDTH + 2;

/** Don't show controls if within this distance of the scroll container edge */
export const CONTROL_BOUNDARY = CARD_WITH_BORDER_WIDTH / 4;

export const CARD_WITH_GUTTER_WIDTH =
  CARD_WITH_BORDER_WIDTH + CAROUSEL_GUTTER_WIDTH;
